import { useSelector } from 'react-redux'
import { Panel } from '../../../common/panel'
import { selectParentCompanyIds } from '../store/slice'
import { downloadParentCompany } from '../store/thunk'
import { ParentCompanyTable } from './ParentCompanyTable'

export const ParentCompany = ({ organizationId }) => {
  const ids = useSelector(selectParentCompanyIds)

  return (
    <Panel
      id="parentCompanies"
      isI18n
      label="companyAnalysis.ownershipAndGroup.PARENT_COMPANIES"
      downloadCsv={{
        disabled: !ids.length,
        downloadFunc: () =>
          downloadParentCompany({ OrganizationId: organizationId }),
      }}
    >
      <ParentCompanyTable />
    </Panel>
  )
}
